import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {

    user:{
      dueDate:''
    },
    url: window.location.host=="192.168.4.211:8080" ? "/apis" : "/api",
    page:{
      sortId:[
        {name:'一级案由',id:'sortId',type:"first",url:'/querySortId',list:[],nowname:'',nowid:[],state:1},
        {name:'具体案由',id:'sortId',type:"son",url:'/querySortId',list:[],nowname:'',nowid:[],state:1},
        {name:'年份',id:'year',type:"owner",url:'/queryYear',list:[],nowname:'',nowid:[],state:1},
        {name:'省份',id:'fcourt',type:"first",url:'/queryFcourt',list:[],nowname:'',nowid:[],state:1},
        {name:'法院',id:'fcourt',type:"son",url:'/queryFcourt',list:[],nowname:'',nowid:[],state:1}
      ]
    },
    chart:{
      sortId:[
        {type:'num',name:'案件数',id:'caseTotal',w:'8'},
        {type:'num',name:'最近一年案件数',id:'recentYearCaseTotal',w:'8'},
        {type:'num',name:'审理法院数',id:'trialCourtTotal',w:'8'},
        {type:'h',name:'案件信息'},
        {area:'dashboard_class001',type:'line',name:'年度分布',id:'countYear',w:'8',h:'420'},
        {area:'dashboard_class001',type:'pie',name:'文书性质',id:'countDocumentProperty',w:'8',h:'420'},
        {area:'dashboard_class001',type:'radar',name:'审理程序',id:'countProcedureTrial',w:'8',h:'420'},
        {area:'dashboard_class001',type:'map',name:'地区分布',id:'countRegion_map',w:'14',h:'420'},
        {area:'dashboard_class001',type:'pie',name:'审理法院等级',id:'countCourtLevel',w:'10',h:'420'},
        {area:'dashboard_class001',type:'bar',name:'地区分布',id:'countRegion_bar',w:'10',h:'460',x:'100'},
        {area:'dashboard_class001',type:'bar',name:'审理法院',id:'countTrialCourt',w:'14',h:'460',x:'260'},

        {type:'h',name:'案件结果'},
        {area:'dashboard_class002',type:'pie',name:'原告胜败诉占比',id:'plaintiffLawsuit',w:'10',h:'400'},
       {area:'dashboard_class002',type:'bar',name:'法条引用-实体法',id:'substantialLaw',w:'14',h:'400',x:'260'},
        {area:'dashboard_class002',type:'pie',name:'案件撤诉占比',id:'withdrawal',w:'10',h:'400'},
        {area:'dashboard_class002',type:'bar',name:'法条引用-程序法',id:'proceduralLaw',w:'14',h:'400',x:'260'},
        {type:'h',name:'案件当事人信息'},
        {area:'dashboard_class003',type:'pie',name:'原告类型 ',id:'plaintiffType',w:'8',h:'320'},
        {area:'dashboard_class003',type:'pie',name:'被告类型',id:'defendantType',w:'8',h:'320'},
        {area:'dashboard_class003',type:'pie',name:'第三人类型',id:'thirdPartyType',w:'8',h:'320'},
        {area:'dashboard_class003',type:'bar',name:'原告TOP10',id:'plaintiffName',w:'8',h:'400',x:'160'},
        {area:'dashboard_class003',type:'bar',name:'被告TOP10',id:'defendantName',w:'8',h:'400',x:'160'},
        {area:'dashboard_class003',type:'bar',name:'第三人TOP10',id:'thirdPartyName',w:'8',h:'400',x:'160'},
        {type:'h',name:'代理人与律所'},
        {area:'dashboard_class004',type:'zoom',name:'相关律所',id:'lawOffice',w:'12',h:'400',y:'140'},
        {area:'dashboard_class004',type:'zoom',name:'相关律师',id:'lawyer',w:'12',h:'400',y:'100'},
      ]
    },
    option:{
      line:{
        title : {text: ''},
        tooltip: {trigger: "item",formatter: "{b} <br/>案件数 : {c}"},
        color:['#6a9bff'],
        grid:{x:90},
        xAxis : [{type : 'category',axisTick:false,data : []}],
        yAxis : [{type : 'value',axisTick:false,splitLine:false,axisLine:{show:false}}],
        series : [{name:'',type:'line',data:[]}]
      },
      pie:{
        title : {text: ''},
        tooltip : {trigger: 'item',formatter: "{b} : {c} <br> 占比 ：{d}%"},
        // legend: {orient: 'vertical',x: 'right'},
        color:['#5182e4','#9bcc66','#3fb27e','#f7cb4a','#f88d48','#f35352'],
        calculable : true,
        series : [{hoverOffset:0,type:'pie',data:[],radius: ['45%', '65%']}]   //{value:'',name:''}
      },
      radar:{
        title: {text: ''},
        tooltip: {trigger: "item"},
        color:['#6a9bff'],
        polar : [{name:{color: '#333'},indicator : [{}],radius: '65%',}],
        series: [{name:'',type: 'radar',data : [{value : []
            // ,label: {color:'#6495ed',show:true}
        }]}]
      },
      map:{
        title : {text: ''},
        tooltip : {trigger: 'item'},
        dataRange: {orient: 'horizontal',color:['#5c8eb0','#dbecf7'],min: 0,max: 100,text:['案件数']},   //获取最大
        series : [{name: '',type: 'map',mapType: 'china',itemStyle:{normal:{label:{show:true}},emphasis:{label:{show:true}}},data:[]}]   //{name:'', value: ''}
      },
      bar:{
        title : {text: ''},
        tooltip: {trigger: "item",formatter: "{b} <br/>案件数 : {c}"},
        color:['#6a9bff'],
        grid:{x:100},
        xAxis : [{type : 'value',axisTick:false,splitLine:false,axisLine:{show:false}}],
        yAxis : [{axisTick:false,type : 'category',data : []}],
        series : [{type:'bar',data:[]}]
      },
      zoom:{
        title : {text: ''},
        tooltip : {trigger: 'item',formatter: "{b} <br/>案件数 : {c}"},
        dataZoom : {show : true,start : 0,end : 10},
        grid:{y2:150},
        color:['#6a9bff'],
        xAxis : [{axisTick:false,axisLabel:{ interval:0,rotate:40},type : 'category',data : []}],
        yAxis : [{type : 'value',axisTick:false,splitLine:false,axisLine:{show:false}}],
        series : [{type:'bar',data:[]}]
      }
    }
  },
})
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js